import { format } from 'date-fns';

const CARD_PROPERTIES = {
  cardNumber: 'number',
  cardType: 'type',
  expiryDate: 'expiry',
};

export default creditCard => Object.keys(CARD_PROPERTIES).reduce((acc, next) => {
  const propName = CARD_PROPERTIES[next];
  switch (propName) {
    case 'number':
      acc[propName] = creditCard
        ? creditCard[next].replace('****-****-****-', '•••• •••• •••• ')
        : '---- ---- ---- ----';
      break;
    case 'expiry':
      if (creditCard) {
        const [month, year] = creditCard[next].split('/');
        acc[propName] = format(new Date(`20${year}`, month - 1), 'MMM YYYY');
      } else {
        acc[propName] = '--- ----';
      }
      break;
    default:
      acc[propName] = creditCard ? creditCard[next] : '-';
  }

  return acc;
}, {});
